module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b",
    attrs: {
      "id": "ch04"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Contents#ch-04"
    }
  }, [_c('span', {
    staticClass: "line"
  }, [_vm._v("THIS OLD HOUSE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('i', [_vm._v("William Winchester’s repeating rifles may have tamed the Wild West, but they sure rattled his widow’s spirits.")])])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('b', [_vm._v("THE MEDIUM GIVES THE MESSAGE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('span', [_vm._v("By most accounts, Sarah Winchester was perfectly normal in 1862 when she married William Winchester. Hubby Will was the marketer of the Winchester repeating rifle used widely on the western frontier. And he was fabulously wealthy. But after the death of her infant child in 1866 and her husband’s death in 1881, Sarah realized that money wasn’t everything. Despite the shares of Win chester stock and cash she’d inherited—a windfall that gave her an income of roughly $1,000 (823 euros) a day—Sarah was so depressed and miserable that she went to a Boston spiritualist for help.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("The Boston medium announced that Sarah’s family died because of, essentially, bad karma. Ghosts of those killed by Winchester rifles were the culprits. Maybe because Sarah already felt guilty about those death-dealing rifles, she believed the ghost story. She didn’t even argue when the spiritualist told her how to appease the angry spirits: The Winchester widow must move out West and build a mansion that would never be finished. As long as she kept on building, Sarah would stay alive.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('b', [_vm._v("WACKY HOME IMPROVEMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('span', [_vm._v("Sarah fled New Haven, Connecticut, for the farming community of San Jose, California, in 1884. She settled into a small farmhouse, set up a séance room, and each night communicated with the spirits who told her what to build next.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("The clatter of hammer and saws filled the house 24 hours a day. Sarah employed a legion of builders who worked in shifts for almost four continuous decades fulfilling Sarah’s odd demands. The result was quite a piece of work: a rambling maze with staircases that led nowhere, more than 2,000 cupboards (some only one inch deep), doorways that opened onto nothing, and balconies with no way to get to them.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Sarah installed five separate central heating systems—despite California’s sunny, warm weather—and strung miles of wire connecting strange communication systems that no one knew how to work. She developed a fixation with the number 13: she built rooms with 13 windows each, 13 fireplaces in one suite, 13 gas lights on her chandelier, 13 holes in her kitchen drain, and so on.")])]), _vm._v(" "), _c('p', {
    staticClass: "center-box"
  }, [_c('span', [_c('b', [_vm._v("The first chewing gum to be widely advertised in the United States was Tutti-Frutti.")])])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("At the end, her house boasted 160 rooms, 3 elevators, 6 kitchens, 40 bedrooms, 47 fireplaces, 17 chimneys, 10,000 windows, and 467 doors—but just 1 shower!")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('b', [_vm._v("GOING TO THE MANSION IN THE SKY")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('span', [_vm._v("Sarah Winchester died at age 83 in 1922, having lived the long life that her spirits had supposedly promised her if she kept building. For the next 16 years the house remained empty. But it was eventually converted into a popular museum, which draws thousands of visitors to San Jose. Ghost tours and nighttime flashlight tours titillate the tourists.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Some say the house is still inhabited. Staff and visitors have reported lights going on and off, and cold spots in certain rooms. Maybe it’s vengeful spirits, angry that the building has ceased. Or maybe it’s Sarah herself, trying to find that shower.")])]), _vm._v(" "), _c('p', {
    staticClass: "centeraa"
  }, [_c('span', [_vm._v("* * * * *")])]), _vm._v(" "), _c('p', {
    staticClass: "centeraa-as"
  }, [_c('span', [_c('b', [_vm._v("LAUGHING STOCK")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('span', [_vm._v("Talk about poetic justice. In Puritan Boston in 1634, a carpenter named Edward Palmer built the first wooden stocks for public punishment. When he then submitted a bill for 1 pound, 13 shillings, and 7 pence, the town officials considered the amount extortionate. They not only fined him 5 pounds but also ordered the carpenter himself to “be sett an houre in the stocks,” the first victim of his own handiwork.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b180422","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter04.vue
// module id = 90
// module chunks = 0